<template>
  <div>
    <template v-if="!isLoading && !sites.length">
      <add-first-site />
    </template>

    <template v-if="!isLoading && sites.length">
<!--            <dashboard-widgets-->
<!--                    v-if="!isLoading"-->
<!--                    :fullName="fullName"-->
<!--                    :sites="sites"-->
<!--                    :allowBetaFeatures="allowBetaFeatures"-->
<!--                    :numberOfSitesRequiringUpdates="numberOfSitesRequiringUpdates"-->
<!--            />-->

      <c-row>
        <c-col sm="12">
          <add-site-button class="float-right ml-1" size="sm"/>
          <template v-if="numberOfSitesRequiringUpdates > 0">
            <c-button
              class="update-all-plugins float-right"
              color="primary"
              size="sm"
              @click="openConfirmUpdateAllSites"
            >
              Update all unblocked plugins on {{ numberOfSitesRequiringUpdates }} site{{
                numberOfSitesRequiringUpdates > 1 ? 's' : ''
              }}
            </c-button>
          </template>
        </c-col>
      </c-row>

      <c-row>
        <c-col v-if="pendingSites.length" sm="12" md="3" class="dashboard-left-panel py-2">
          <div class="dashboard-panel-scroll">
            <pending-sites :sites="pendingSites" @siteIgnored="removeFromPendingList"/>
          </div>
        </c-col>
        <c-col sm="12" :md="pendingSites.length ? 9 : 12">
          <c-tabs>
            <c-tab title="Sites" active>
              <template #title>
                <site-icon />
                Sites
                <pill :value="numberOfSites" />
              </template>
              <div class="dashboard-panel-scroll">
                <site-list
                    hide-add-site-button
                    :sites="sites"
                    :hide-header="true"
                    :show-only-require-updates="true"
                />
              </div>
            </c-tab>
            <c-tab title="Plugins">
              <template #title>
                <plugin-icon />
                Plugins
                <pill :value="pluginSummary.length" width="40px" />
              </template>
              <div class="dashboard-panel-scroll">
                <plugin-list
                    :plugins="pluginSummary"
                    :hide-header="true"
                    :show-only-require-updates="true"
                    :view-type-default="'grid'"
                />
              </div>
            </c-tab>
          </c-tabs>
        </c-col>
      </c-row>
    </template>

    <confirm-modal :title="updateAllSitesTitle" :show.sync="showUpdateAllSites" @update:confirm="doUpdateAllSites">
      <div v-html="updateAllSitesMessage" />
    </confirm-modal>
  </div>
</template>

<script>
import { freeSet } from '@coreui/icons';
import { mapGetters, mapActions } from 'vuex';
import { buildEndpoint } from '@/libs/buildEndPoint';
import { getPluginUrl } from '@/libs/plugin/getPluginUrl';
import SiteList from '../components/site-list-v2';
import PendingSites from '../components/pending-sites';
import Plugins from '../components/dashboard/plugins';
import PluginList from '../components/plugin-list';
import DashboardWidgets from '../components/dashboard/widgets';
import Pill from '../components/Pill';
import PluginIcon from '../components/icons/plugin';
import SiteIcon from '../components/icons/site';
import AddFirstSite from '@/views/components/dashboard/AddFirstSite';
import ConfirmModal from '@/views/components/ConfirmModal';
import AddSiteButton from '@/views/components/site/add-site-button.vue';

export default {
  name: 'Dashboard',

  components: {
    SiteList,
    DashboardWidgets,
    Plugins,
    PluginList,
    Pill,
    PluginIcon,
    SiteIcon,
    AddFirstSite,
    ConfirmModal,
    PendingSites,
    AddSiteButton,
  },

  data() {
    return {
      freeSet,
      sites: [],
      pendingSites: [],
      isLoading: true,
      isScraping: false,
      status: false,
      error: null,
      numberOfSites: 0,
      uniquePluginCount: 0,
      numberOfSitesRequiringUpdates: 0,
      mostPopularPlugin: false,
      visible: true,
      pluginSummary: null,
      pluginUrl: null,
      fullName: '',
      showUpdateAllSites: false,
      updateAllSitesRequestQueued: false,
      sitesViewType: 'grid',
    };
  },

  created() {
    this.pluginUrl = getPluginUrl();
    this.fullName = `${this.$store.state.app.authenticatedUser.firstName} ${this.$store.state.app.authenticatedUser.lastName}`;
    this.fetchData();
  },

  computed: {
    ...mapGetters({
      notificationSidebar: 'notificationSidebar',
      siteUpdates: 'siteUpdates',
      allowBetaFeatures: 'allowBetaFeatures',
    }),
    getStartedUrl() {
      return _.get(this.$store.state, 'app.authenticatedUser.organisation.getStarted.url');
    },
    getStartedScreenshotUrl() {
      return _.get(this.$store.state, 'app.authenticatedUser.organisation.getStarted.screenshotUrl');
    },
    updateAllSitesTitle() {
      return `Update all plugins (${this.numberOfSitesRequiringUpdates} site${
        this.numberOfSitesRequiringUpdates > 1 ? 's' : ''
      })`;
    },
    updateAllSitesMessage() {
      return 'Update all plugins on all sites (except plugins you’ve blocked)';
    },
  },

  methods: {
    ...mapActions(['toggleNotifications', 'queueSiteUpdate']),
    fetchData() {
      this.isLoading = true;
      this.status = 'Getting data...';
      const _this = this;
      _this.sites = [];
      _this.pendingSites = [];
      _this.pluginSummary = [];
      _this.updatesRequired = 0;
      _this.numberOfSites = 0;
      _this.numberOfSitesRequiringUpdates = 0;
      this.$http({
        url: buildEndpoint('dashboard/get-data'),
      })
        .then((response) => {
          if (response.data.success) {
            const responseData = response.data.data;
            // Set site data

            // if (responseData.sites.length === 0) {
            //   return this.$router.replace('/add-a-site');
            // }

            responseData.sites.forEach((site) => {
              _this.numberOfSites++;
              if (site.updatesRequired > 0) {
                _this.numberOfSitesRequiringUpdates++;
              }
              _this.sites.push(site);
            });
            if (responseData.pendingSites) {
              _this.pendingSites = responseData.pendingSites;
            }
            // _this.sites = _.orderBy(_this.sites, ['updatesRequired', 'Name'], ['desc', 'asc']);
            // Set plugin data
            _this.uniquePluginCount = responseData.pluginSummary.length;
            _this.mostPopularPlugin = responseData.pluginSummary[0];
            _this.pluginSummary = responseData.pluginSummary;
          } else {
            this.error = 'Error getting data';
          }
          this.isLoading = false;
          this.status = false;
          this.error = null;
          if (this.$route.query.refresh === '1') {
            this.scrapeAll();
          }
        })
        .catch(() => {
          this.status = false;
          this.isLoading = false;
          this.error = 'Error getting data';
        });
    },
    scrapeAll() {
      this.error = null;
      this.$http({
        url: buildEndpoint('dashboard/scrape-all-sites'),
      })
        .then((response) => {
          // Nothing to do...we've added all sites to the refresh queue
        })
        .catch((error) => {
          this.error = error;
        });
    },
    openConfirmUpdateAllSites() {
      this.showUpdateAllSites = true;
    },
    closeUpdateAllSites() {
      this.showUpdateAllSites = false;
    },
    siteUpdateTitle() {
      return `Update all plugins (${this.sites.length} site${this.sites.length > 1 ? 's' : ''})`;
    },
    siteUpdateMessage() {
      return `Update all plugins on all sites (except plugins you’ve blocked)`;
    },
    doUpdateAllSites() {
      // Do updates
      this.updateAllSitesRequestQueued = true;
      this.showUpdateAllSites = false;
      this.$http
        .get(buildEndpoint('site/plugin/update-all-sites'))
        .then((response) => {
          this.error = null;
          if (response.data.success) {
            this.$store.commit('addSuccessMessage', {
              header: 'Success',
              message: response.data.message,
            });
            setTimeout(() => {
              this.$store.commit('toggle', 'asideShow');
            }, 2000);
          } else {
            this.updateAllSitesRequestQueued = false;
            this.error = 'There was a problem updating all sites';
            this.$store.commit('addErrorMessage', {
              header: 'Error',
              message: 'There was a problem updating all sites',
            });
          }
        })
        .catch((error) => {
          this.updateAllSitesRequestQueued = false;
          this.$store.commit('addErrorMessage', {
            header: 'Error',
            message: error,
          });
        });
    },
    removeFromPendingList(siteId) {
      this.pendingSites = this.pendingSites.filter((site) => site._id !== siteId);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/colors.scss';
.dashboard-panel-scroll {
  height: calc(100vh - 280px);
  margin-bottom: 10px;
  overflow-x: auto;
}
.dashboard-left-panel {
  background: $kb-green;
}
</style>
